import { useEffect } from "react";

import { usePostHog } from "posthog-js/react";

import { Queries } from "@/queries/Queries.ts";

/**
 * Ties the PostHog session to the signed-in patient.
 * Must be called from inside the authenticated tree: `useMe` suspends.
 */
export const useInitPostHog = () => {
  const me = Queries.patient.useMe({});
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.identify(me.id, { email: me.email });
  }, [posthog, me.id, me.email]);
};
